
  <div class="{{borderColor}}  hover:shadow-8 border-2 border-round-lg shadow-5">
  <div class="p-grid">
  <div class="p-col-4">
    <p-card class="text-sm" [style]="{width:'290px',height:'225px'}">
      <ng-template pTemplate="content">
        <div class="grid">
          <div class="col-3">
            <div class="image-container" >
              <!-- <img class="circular-image" [src]="FRAPPE_API_URL + vendor.propertiery_img" style="border-radius: 100%;overflow: hidden;object-fit:cover;height:70px;width:70px" alt="{{ vendor.business_name }}" style="width: 100%; height: auto;"> -->
              <p-avatar
    *ngIf="vendor.propertiery_img"
    [image]="FRAPPE_API_URL + vendor.propertiery_img"
    size="xlarge"
    shape="circle"
    ></p-avatar>
    <p-avatar
    *ngIf="!vendor.propertiery_img || vendor.propertiery_img === ''"
    image="https://netmat.in/demo/vendor/img/user.png"
    size="xlarge"
    shape="circle"
    ></p-avatar>
<!-- <img
    *ngIf="!vendor.propertiery_img || vendor.propertiery_img === ''"
    src="https://netmat.in/demo/vendor/img/user.png"
    alt="{{ vendor.business_name }}"
    style="border-radius: 100%; overflow: hidden; object-fit: cover; height: 70px; width: 70px;"
> -->
            </div>
          </div>
          <div class="col-9">
            <div class="details-container">
              <p  class="text-sm email-container" title="{{ vendor.business_name }}"><i class="pi pi-user" style="margin-right: 0.5rem;"></i><strong>{{ vendor.business_name }}</strong></p>
              <!-- <p class="text-sm" title="{{ vendor.business_name }}">
                <i class="pi pi-user" style="margin-right: 0.5rem;"></i>
                <strong>
                  {{ vendor.business_name.length > 25
                    ? vendor.business_name.substring(0, 22) + '...'
                    : vendor.business_name }}
                </strong>
              </p> -->
              <p  class="text-sm"><i class="pi pi-credit-card" style="margin-right: 0.5rem;"></i><strong>{{ vendor.vendor_code }}</strong></p>
              <p class="text-sm"><i class="pi pi-phone" style="margin-right: 0.5rem;"></i><strong>{{ vendor.mobile_no }}</strong></p>
              <p class="text-sm email-container" title="{{ vendor.get_user }}"><i class="pi pi-envelope" style="margin-right: 0.5rem;"></i><strong>{{ vendor.get_user }}</strong></p>
              <!-- <p class="text-sm" title="{{ vendor.contact_person.e_mail_id }}">
                <i class="pi pi-envelope"></i>
                <strong>
                  {{ vendor.contact_person.e_mail_id.length > 10
                    ? vendor.contact_person.e_mail_id.substring(0, 22) + '...'
                    : vendor.contact_person.e_mail_id }}
                </strong>
              </p> -->
              <p class="text-sm"><i class="pi pi-globe" style="margin-right: 0.5rem;"></i><strong>{{ vendor.country }}</strong></p>
              <p class="text-sm"><i class="pi pi-id-card" style="margin-right: 0.5rem;"></i><strong>{{ vendor.pan_no }}</strong></p>
              <p class="text-sm"><i class="fas fa-file-invoice" style="margin-right: 0.5rem;"></i><strong>{{ vendor.gstn}}</strong></p>
            </div>
          </div>
        </div>
        <div class="grid">
            <div class="col-4">
                <i class="pi pi-eye" style="font-size:medium;cursor:pointer" (click)="onDetail(vendor.get_user,vendor.status,vendor.business_name)"></i>
            </div>
            <div class="col-8" style="text-align:end; margin-bottom: 5px;" >
                <span class="text-sm" *ngIf="vendor.status === 'PENDING_APPROVER_1'">Status: <i class="text-sm"style="color:#FFA500; background-color:#FFF7D4; border: solid 1px orange; padding: 4px; padding-left: 4px; padding-right: 2px; border-radius: 5px;" >Approval 1 Pending</i></span>
                <span class="text-sm" *ngIf="vendor.status === 'PENDING_APPROVER_2'">Status: <i class="text-sm"style="color:#FFA500; background-color:#FFF7D4; border: solid 1px orange; padding: 4px; padding-left: 4px; padding-right: 2px; border-radius: 5px;" >Approval 2 Pending</i></span>
                <span class="text-sm" *ngIf="vendor.status === 'PENDING_CPO_APPROVAL'">Status: <i class="text-sm"style="color:#FFA500; background-color:#FFF7D4; border: solid 1px orange; padding: 4px; padding-left: 4px; padding-right: 2px; border-radius: 5px;" >CPO Approval</i></span>
                <span class="text-sm" *ngIf="vendor.status === 'APPROVED'" >Status: <i class="text-sm" style="color:green; background-color: rgba(76, 175, 80, 0.1); border: solid 1px green; padding: 4px; padding-left: 4px; padding-right: 2px; border-radius: 5px;">Approved</i></span>
                <span class="text-sm" *ngIf="vendor.status === 'REJECT'" >Status: <i class="text-sm" style="color:red; background-color: rgba(76, 175, 80, 0.1); border: solid 1px green; padding: 4px; padding-left: 4px; padding-right: 2px; border-radius: 5px;">Rejected</i></span>
            </div>

        </div>
      </ng-template>
      <!-- <ng-template class="text-sm" pTemplate="footer">
        <div class="d-flex justify-content-between w-100">
          <button pButton type="button" class="pi pi-eye"></button>
          <span class="text-sm" *ngIf="vendor.status === 'PENDING_ADMIN_APPROVAL'">Status: Pending</span>
          <span class="text-sm" *ngIf="vendor.status === 'APPROVED'" >Status: Approved</span>
        </div>
      </ng-template> -->
    </p-card>
  </div>
</div>
</div>


